import React, {
    useContext,
    useEffect,
    useState
} from 'react';
import Head from 'next/head';

import { RequestNextApi } from '../../../api/Request';
import { ProgressContext } from '../../../components/Context/progressContext';
import MarketingNavigation from '../../../navigation/marketing';
import { ShowNotification } from '../../../utils/notification/snackbarUtils';
import { showArticleBlock } from '../../../utils/static-pages/function';
import { PAGES_SLUG } from '../../../utils/static-pages/model';

export default function VirtualStudyGroups() {
    const [articleBlocks, setArticleBlocks] = useState();
    const { state: progressContext, update: updateProgress } = useContext(ProgressContext);

    useEffect(() => {
        const fetchPage = async () => {
            try {
                const res = await RequestNextApi.post('/pages',
                    {
                        slug: PAGES_SLUG.MARKETING_VIRTUAL_STUDY_GROUPS,
                    }
                );
                if (res.data.success) {
                    setArticleBlocks(res.data.page.articleBlocks);
                } else {
                    ShowNotification.error('Fetch page failed');    
                }
            } catch (error) {
                ShowNotification.error('Fetch page failed');
            }
        };

        const initPage = async () => {
            updateProgress({isLoading: true});
            await fetchPage();
            updateProgress({isLoading: false});
        };

        initPage();
    }, []);

    return (
        <>
            <Head>
                <title>Join Virtual Study Groups | Kingdom Advisors</title>
                <meta name="description" content="Participate in Kingdom Advisors' virtual Study Groups. Join from anywhere and gain insights into aligning clients' values and financial decisions." />
            </Head>
            <MarketingNavigation>
                <div className='marketing-home--community-study-groups'>
                    {articleBlocks?.map((item, index) => (
                        showArticleBlock(item, index)
                    ))}
                </div>
            </MarketingNavigation>
        </>
    )
}

VirtualStudyGroups.getLayout = page => <>{page}</>;
VirtualStudyGroups.isPublic = true;
